import { render, staticRenderFns } from "./UserTicketList.vue?vue&type=template&id=2d62b9cf&scoped=true&"
import script from "./UserTicketList.vue?vue&type=script&lang=js&"
export * from "./UserTicketList.vue?vue&type=script&lang=js&"
import style0 from "./UserTicketList.vue?vue&type=style&index=0&id=2d62b9cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d62b9cf",
  null
  
)

export default component.exports